import { useSelector } from 'react-redux';
import { selectClient } from '@/model/selectors';

/**
 * Returns true when the client is on claim or already past their predicted
 * LTC start age — i.e. there is no remaining projection horizon. Used to gate
 * UI that only makes sense before LTC begins (growth/contribution inputs,
 * policy selection steps, etc.).
 */
export function useCareHasStarted(): boolean {
  const client = useSelector(selectClient);
  const clientHasStartedLtc = !!client?.intakeSurvey?.clientHasStartedLtc;
  const yearsTillLtc = client?.appliedInferenceSet?.yearsTillLtc;
  return clientHasStartedLtc || (yearsTillLtc != null && yearsTillLtc <= 0);
}
